<template>
    <div id="thank-you-message">
        <svg id="checkmark" class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
            <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>        
        <p>Thank you for your visit.</p>
        <p>We look forward to your return.</p>
    </div>
</template>

<script>
    export default {
        name: "ThankYouMessage"
    }
</script>

<style scoped>
    #thank-you-message {
        font-weight: bold;
        background-color: var(--white);
        padding: 10px 0 0 0;
        text-align: center;
    }

        #thank-you-message p:nth-child(2) {
            font-size: 18px;
        }

        #thank-you-message p:nth-child(3) {
            font-weight: normal;
        }

    #checkmark {
        margin: 30px auto;
    }
</style>